import React, { useState, useEffect, useRef } from 'react';
//import Select from 'react-select';
import axios from "axios";
import avatar from 'assets/img/default.jpg';
import ConnectedUnits from './ConnectedUnits'
import toast, { Toaster } from 'react-hot-toast';
import './Users.scss';
import validator from 'validator';

const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
});

async function isEmailUsed(email) {
    try {
      const resUser = await API.post("/admin/users/by-email",{'email':email});
      return (resUser.data.email == email);
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data);
      return undefined
    }
}



export default function CreateUserForm(props) {

    const closeForm = props.cancel;
    const saveUserDetails = props.confirm;

    const emptyForm = {
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        company_id: '0',
        country: '',
        status: '1',
        super_user: '0',
        password: '', 
        password_confirm: ''
    }
    const [showForm, setShowForm] = useState(false)
    const [newDetails, setNewDetails] = useState(emptyForm)
    const noCompany = {'id':0, 'company_name': 'Not assigned'};
    const [companies, setCompanies] = useState([noCompany])
    const [matchingPwd, setMatchingPwd] = useState(true);
    const [missingPwd, setMissingPwd] = useState(false);
    const [validEmail, setValidEmail] = useState(true);




    async function getCompanies() {
        try {
          const res = await API.post("/admin/companies");
          let companyList = res?.data;
          companyList.unshift(noCompany)
          setCompanies(companyList);
        } catch (error) {
          console.log(error?.response?.data);
          toast.error(error?.response?.data);
        }
    }

    const checkValues = async (e) => {

        let valuesValid = true;

        if (newDetails.first_name === "" || newDetails.last_name === "") {
            toast.error("Please enter Name.")
            valuesValid = false;
        }
        if (newDetails.email !== "" ) {
            if (validator.isEmail(newDetails.email)) {
                let userExist = await isEmailUsed(newDetails.email)
                if(userExist) {
                    toast.error("User "+newDetails.email+" already exist.")
                    setValidEmail(false)
                    valuesValid = false;
                } else {
                    setValidEmail(true)
                }
            } else {
                toast.error("Email is not correctly formatted.")
                setValidEmail(false)
                valuesValid = false;
            }
        } else {
            toast.error("An email address needs to be entered.")
            setValidEmail(false)
            valuesValid = false;
        }



        if (newDetails.password_new !== newDetails.password_new_confirm || (newDetails.password_new === "" && newDetails.password_new_confirm === "")) {
            toast.error("New passwords missing or doesn't match")
            setMatchingPwd(false)
            valuesValid = false;
        } 
        if (newDetails.password_old === "" && (newDetails.password_new !== "" || newDetails.password_new_confirm !== "")) {
            toast.error("Old password missing")
            setMissingPwd(true)
            valuesValid = false;
        }
        
        if (valuesValid) {
            saveUserDetails(newDetails)
        }
    }

    useEffect(() => {
        if (newDetails.password_new === newDetails.password_new_confirm && 
            newDetails.password_new !== "" && 
            newDetails.password_new_confirm !== "" ) {
            setMatchingPwd(true)
        }
        if (newDetails.password_old !== "" && missingPwd) {
            setMissingPwd(false)
        }
    }, [newDetails]);

    useEffect(() => {
        getCompanies();
    }, [])

    const backdrop = useRef(null)
    const addForm = useRef();

    return (
            <div id="add" className="modal fade show" tabIndex="-1" role="dialog" style={{display: "block", paddingRight: 5 + 'px'}} aria-modal="true">
                <div className="modal-dialog" role="document">
                    <div ref={addForm} className="modal-content">
                        <div className="modal-header">
                            <button onClick={() => closeForm()} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title" data-locale="Edit User">Edit</h4>
                        </div>
                        <div className="modal-body">
                            <form className="form-horizontal">
                                <input type="hidden" name="id" value="1" />
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="First Name">First Name</label>
                                    <div className="col-sm-7">
                                        <input type="text" className={`form-control ${ newDetails.first_name ? '' : 'input-error'}`}   id="first_name" name="first_name" placeholder="First Name" 
                                        onChange={(e) => setNewDetails({...newDetails, first_name: e.target.value})} value={newDetails.first_name} />
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Last Name">Last Name</label>
                                    <div className="col-sm-7">
                                        <input type="text" className={`form-control ${ newDetails.last_name ? '' : 'input-error'}`}  name="last_name" placeholder="Last Name" 
                                        onChange={(e) => setNewDetails({...newDetails, last_name: e.target.value})} value={newDetails.last_name} />
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Email">Email</label>
                                    <div className="col-sm-7">
                                        <input type="text" className={`form-control ${ newDetails.email && validEmail ? '' : 'input-error'}`}   id="email" name="email" placeholder="Email" 
                                        onChange={(e) => setNewDetails({...newDetails, email: e.target.value})} value={newDetails.email} />
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Company Name">Company Name</label>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-control" name="company" placeholder="" 
                                        onChange={(e) => setNewDetails({...newDetails, company: e.target.value})} value={newDetails.company} />
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Company ID">Company ID</label>
                                    <div className="col-sm-7">
    
                                        <select className="form-control" name="company_id" id="companyId" 
                                            onChange={(e) => setNewDetails({...newDetails, company_id: e.target.value})} value={newDetails.company_id}>
                                            {companies.map((company) => <option key={company.id} value={company.id}>{company.company_name}</option>)}
                                        </select>
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Country Name">Country Name</label>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-control" name="country" placeholder="" 
                                        onChange={(e) => setNewDetails({...newDetails, country: e.target.value})} value={newDetails.country} />
                                    </div>
                                </div>
    
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Status">Status</label>
                                    <div className="col-sm-7">
    
                                        <select className="form-control" name="status"
                                            onChange={(e) => setNewDetails({...newDetails, status: e.target.value})} value={newDetails.status} >
                                            <option data-locale="enabled" value="1">Enabled</option>
                                            <option data-locale="disabled" value="0">Disabled</option>
                                        </select>
    
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label form-control-label" data-locale="Admin">Admin</label>
                                    <div className="col-sm-7">
                                        <select className="form-control" name="super_user"
                                            onChange={(e) => setNewDetails({...newDetails, super_user: e.target.value})} value={newDetails.super_user} >
                                            <option data-locale="yes" value="1">yes</option>
                                            <option data-locale="no" value="0">no</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                        <label className="control-label" data-locale="Enter Password" autoComplete="password">Password</label>
                                        <input type="password" className={`form-control ${ matchingPwd ? '' : 'input-error'}`} name="password" placeholder="New Password" autoComplete="off" 
                                        onChange={(e) => setNewDetails({...newDetails, password: e.target.value})} value={newDetails.password} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                        <label className="control-label" data-locale="Confirm Password" autoComplete="password">Confirm Password</label>
                                        <input type="password" className={`form-control ${ matchingPwd ? '' : 'input-error'}`} name="password_confirmation" placeholder="Confirm New Password" autoComplete="off" 
                                        onChange={(e) => setNewDetails({...newDetails, password_confirm: e.target.value})} value={newDetails.password_confirm}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-10" style={{textAlign: 'right'}}>
                                        <button onClick={() => closeForm()} type="button" className="btn btn-default" data-dismiss="modal" data-locale="close">
                                            Cancel
                                        </button>
                                        <button onClick={(e) => checkValues(e)} type="button" className="btn btn-primary save" data-locale="save">
                                            Save
                                        </button>
                                    </div>
                                </div>
    
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )

}